import { put, select } from 'redux-saga/effects';
import {
  enqueueErrorSnackbar,
  enqueueSuccessSnackbar,
} from '../notifications/actionWrapper';

import { api } from '../utils/api';
import { translate } from '../../utils/translation';
import { selectSelectedLanguage } from '../userData/selectors';
import { sendCurrencyAction } from '../../utils/googleAnalytics';

export function fetchCurrencySagaFactory(actions) {
  return function* () {
    const lang = yield select(selectSelectedLanguage);
    try {
      const { data } = yield api.get('currency-rates-data');
      if (data) {
        yield put(actions.fetchCurrencySuccess(data));
      }
    } catch (e) {
      yield put(actions.fetchCurrencyError(e));
      yield put(
        enqueueErrorSnackbar(
          translate('snackbarMessages.couldNotFetchCurrencyData', lang),
        ),
      );
    }
  };
}

export function updateCurrencySagaFactory(actions) {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    try {
      sendCurrencyAction('UpdateCurrency');
      const { data } = yield api.post(
        `currency-rates-data/${payload.fy}`,
        payload.factors,
      );
      if (data) {
        yield put(actions.updateCurrencySuccess(payload));
        yield put(
          enqueueSuccessSnackbar(
            translate(
              'snackbarMessages.successfullyUpdatedCurrencyRates',
              lang,
            ),
          ),
        );
      }
    } catch (e) {
      yield put(actions.updateCurrencyError(e));
      yield put(
        enqueueErrorSnackbar(
          translate('snackbarMessages.couldNotUpdateCurrencyData', lang),
        ),
      );
    }
  };
}
